import React from "react";
import { useEventHandler } from "src/components/base/hooks/useEventHandler";
import { useGiftFlow } from "src/components/feature/giftFlow/useGiftFlow";
import { constants } from "src/shared/constants";

export function GlobalEventListener() {
  const { onLoginApiSuccess } = useGiftFlow();

  useEventHandler({
    name: constants.customEvents.loginApiSuccess,
    handler: (ev: any) => {
      onLoginApiSuccess(ev);
    },
  });

  return <></>;
}
